import { useSortable } from '@dnd-kit/sortable';
import type { CSSProperties } from 'react';

import { useSwimlaneRootProps, useSwimlaneState } from '@/components/ui/swimlane/context';
import type { TCardId } from '@/components/ui/swimlane/types';
import { CELL_GAP, SORTABLE_TYPES } from '../../constants';
import { CardDropIndicator, useIsCardDragging, useIsDragAboveCenter } from '../../dnd';

import { CardRenderer } from './CardRenderer';

const draggingStyle: CSSProperties = { opacity: 0.3 };
const wrapperStyle = { gap: CELL_GAP.label };

export function SortableCard({ cardId, ...rest }: { cardId: TCardId }) {
  const { readOnly } = useSwimlaneRootProps();
  const { getCardProps, onCardMount, onCardUnmount } = useSwimlaneState();
  const cardProps = getCardProps(cardId);
  const isDragDisabled = readOnly || (cardProps?.isDragDisabled ?? false);
  const { setNodeRef, attributes, listeners, isOver } = useSortable({
    id: cardId,
    data: {
      cardId,
      type: SORTABLE_TYPES.Card,
      accepts: [SORTABLE_TYPES.Card],
    },
    disabled: isDragDisabled,
  });
  const isDragging = useIsCardDragging(cardId);
  const isAboveCenter = useIsDragAboveCenter();

  return (
    <div ref={setNodeRef} className="flex flex-col" style={wrapperStyle}>
      {isOver && isAboveCenter && <CardDropIndicator cardId={cardId} />}
      <div {...attributes} {...listeners} style={isDragging ? draggingStyle : undefined}>
        <CardRenderer cardId={cardId} {...{ ...rest, onCardMount, onCardUnmount }} />
      </div>
      {isOver && !isAboveCenter && <CardDropIndicator cardId={cardId} />}
    </div>
  );
}
